export default __webpack_public_path__ + "static/media/blue-pin-1.85437596.svg";